import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { configEndpoint, shipmentEndpoint } from 'src/app/utils/constants/requestUrl';
import { DexieDbService } from './dexie-db.service';

@Injectable()
export class ConfigService {
  constructor(private http: HttpClient, private db: DexieDbService) {}

  validateConfiguration() {
    return this.http.get(`${environment.configUrl}${configEndpoint.defaultConfiguration}`);
  }

  getMappingFields(id, format): Observable<any> {
    const reqBody = {
      config_queries: [
        {
          config_id: id,
          file_format: format,
        },
      ],
    };
    return this.http.post<any>(
      `${environment.configUrl}${configEndpoint.getConfiguration}`,
      reqBody
    );
  }

  getListOfMappings(configId): Observable<any> {
    return this.getConfig(configId);
  }

  getMappingFromOption(configId, spec_id): Observable<any> {
    const reqBody = {
      config_queries: [
        {
          config_id: configId,
          specifications_id: spec_id,
        },
      ],
    };
    return this.http.post<any>(
      `${environment.configUrl}${configEndpoint.getConfiguration}`,
      reqBody
    );
  }

  getDestinationCountryMapping(): Observable<any> {
    return this.getConfig([{ config_id: 'mother_baby_destcountry_mapping' }]);
  }

  getEmailConfigurationList(): Observable<any> {
    return this.getConfig([{ config_id: 'prealert_emails' }]);
  }

  getPrealertReportparams(): Observable<any> {
    return this.getConfig([{ config_id: 'prealert_reportparams' }]);
  }

  getConfig(config): Observable<any> {
    let reqBody = {};
    if (typeof config === 'string') {
      reqBody = {
        config_queries: [
          {
            config_id: config,
          },
        ],
      };
    } else {
      reqBody = {
        config_queries: config,
      };
    }
    return this.http.post<any>(
      `${environment.configUrl}${configEndpoint.getConfiguration}`,
      reqBody
    );
  }

  saveConfig(data): Observable<any> {
    return this.http.post(`${environment.configUrl}${configEndpoint.addConfiguration}`, data);
  }

  saveMappingOption(data) {
    return this.http.post(`${environment.configUrl}${configEndpoint.addConfiguration}`, data);
  }

  getallSpecList(data): Observable<any> {
    return this.http.post(`${environment.shipmentUrl}${shipmentEndpoint.getShipmentList}`, data);
  }

  getLineItemsSpecifications(requestBody) {
    return this.http.post(
      `${environment.configUrl}${configEndpoint.getConfiguration}`,
      requestBody
    );
  }

  deleteConfig(reqBody) {
    return this.http.delete(
      `${environment.configUrl}${configEndpoint.deleteConfiguration}`,
      reqBody
    );
  }

  fetchConfig(configId: string) {
    return this.db.getConfig(configId);
  }

  putConfig(config_id: string, data: any) {
    return this.db.saveConfig(config_id, data);
  }

  getConfigs(configIds: string[]): Promise<any[]> {
    const promises = configIds.map(configId => {
      return this.db.config
        .where('config_id')
        .equals(configId)
        .first()
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    });
    return Promise.all(promises);
  }
}
